export default __webpack_public_path__ + "static/media/FS-HOME-ACERCA-BENEFICIO-INNOVACION-ICONO.33d1674d.svg";